import app from '$$app';
import Dnd from '../../grid/dnd';

export default instance => {
  const helper = instance.utils.dom;
  let activeTaskId = null;

  return (taskId, event) => {
    const chartState = instance.getState();
    const isChartDnD = chartState.drag_mode === 'move' || chartState.drag_mode === 'resize';

    if (taskId && !Dnd.isDragging && !isChartDnD && instance.isTaskExists(taskId)) {
      const node = helper.closest(event.target, '.gantt_cell');
      const isAssigneCell = node ? helper.hasClass(node, 'assign') && !!node.querySelector('.resource-in-grid') : false;

      if (activeTaskId && (activeTaskId !== taskId || !isAssigneCell)) {
        activeTaskId = null;
        app.trigger('hideResourcesPreviewListForTask');
      }

      if (isAssigneCell && !activeTaskId) {
        const task = instance.getTask(taskId);
        const position = node.getBoundingClientRect();

        position.y += 1;
        activeTaskId = taskId;

        app.trigger('showResourcesPreviewListForTask', position, task.id, task.gantt_id);
      }
    } else if (activeTaskId && !helper.closest(event.target, '#task_resources_preview')) {
      activeTaskId = null;
      app.trigger('hideResourcesPreviewListForTask');
    }
  };
};
